/**
 * O que faz: soma consultas pagas e vendas do CRM no faturamento do período.
 * Onde usa: dashboardService e testes do card Faturamento realizado.
 * Conexões: formas de pagamento da agenda + rótulo de vendas do Kanban.
 * Tabelas: nenhuma; recebe listas já filtradas por data.
 * Data: 25/08/2026
 */

import { FORMAS_PAGAMENTO_AGENDAMENTO, rotuloFormaPagamento } from '@/constants/pagamentoAgendamento';

export const FORMA_VENDA_CRM = 'venda_crm';
export const ROTULO_VENDA_CRM = 'Vendas do CRM';

const somarValor = (itens: Array<{ valor?: unknown }>): number =>
  itens.reduce((total, item) => total + (Number(item.valor) || 0), 0);

export const montarFaturamentoDashboard = (
  pagamentosAgenda: Array<{ valor?: unknown; forma_pagamento?: string | null }>,
  vendasCrm: Array<{ valor?: unknown }>,
) => {
  const faturamentoConsultas = somarValor(pagamentosAgenda);
  const faturamentoVendas = somarValor(vendasCrm);
  const faturamentoPorFormaMap = new Map<string, number>();

  for (const opcao of FORMAS_PAGAMENTO_AGENDAMENTO) {
    faturamentoPorFormaMap.set(opcao.value, 0);
  }

  for (const pagamento of pagamentosAgenda) {
    const forma = pagamento.forma_pagamento || 'outro';
    faturamentoPorFormaMap.set(forma, (faturamentoPorFormaMap.get(forma) || 0) + (Number(pagamento.valor) || 0));
  }

  if (faturamentoVendas > 0) {
    faturamentoPorFormaMap.set(FORMA_VENDA_CRM, faturamentoVendas);
  }

  const faturamentoPorForma = Array.from(faturamentoPorFormaMap.entries())
    .map(([forma, valor]) => ({
      forma,
      rotulo: forma === FORMA_VENDA_CRM ? ROTULO_VENDA_CRM : rotuloFormaPagamento(forma),
      valor,
    }))
    .filter((item) => item.valor > 0);

  return {
    faturamentoConsultas,
    faturamentoVendas,
    faturamentoRealizado: faturamentoConsultas + faturamentoVendas,
    faturamentoPorForma,
  };
};
